// Angular Files
import { Provider } from '@angular/core';

// Angular Material Files
import {
    MAT_FORM_FIELD_DEFAULT_OPTIONS,
    MatFormFieldDefaultOptions
} from '@angular/material/form-field';

// App-wide Material form-field defaults. We render every `mat-form-field` with
// the `outline` appearance; setting it here once is the framework-blessed way to
// do that, so individual templates never set `appearance` themselves.
//
// Hints and errors use 'dynamic' sizing so a message longer than one line pushes
// the next field down instead of being drawn over it (QA 3.1.18). 'dynamic' alone
// reserves nothing, so styles/_global-chrome.scss keeps Material's one-line spacer
// under fields with no message, which keeps a form still when errors appear.
export const MAT_FORM_FIELD_OUTLINE_DEFAULTS: Provider = {
    provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
    useValue: {
        appearance: 'outline',
        subscriptSizing: 'dynamic'
    } satisfies MatFormFieldDefaultOptions
};
